export default "__VITE_ASSET__a51603cd__"